import ApiBase from 'app/services/api/entities/Base'

const BASE_URL = '/v1/nexfolders/'

function* all(params = {}) {
  return yield ApiBase.privateGet(BASE_URL, {
    params
  })
}

export default {
  all,
}
